import { render } from "./ThreeJSScene.vue?vue&type=template&id=70074b90&scoped=true"
import script from "./ThreeJSScene.vue?vue&type=script&lang=js"
export * from "./ThreeJSScene.vue?vue&type=script&lang=js"

import "./ThreeJSScene.vue?vue&type=style&index=0&id=70074b90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70074b90"]])

export default __exports__